<template>
    <div id="app">
        <div class="bg-box">
            <!-- <img src="@/assets/image/main/bg.png" alt="" class="bg" /> -->
            <div class="line">
                <img
                    src="@/assets/image/main/indexline.png"
                    alt=""
                    class="ie"
                />
                <router-view />
            </div>
        </div>
        <Daoh />
        <Music />
        <img src="@/assets/image/main/bg.png" class="body-bg" />
    </div>
</template>

<script>
import Daoh from "@/components/navigation.vue";
import Music from "@/components/music.vue";
import { getAction } from '@/api/manage'
export default {
    components: {
        Daoh,
        Music,
	},
	created() {
		// this.getAccessToken()
		// this.getJsapiTicket()
	},
	mounted() {
		this.wxConfig()
	},
    data() {
        return {
			appId: 'wx87e84ecc904bcb0d',
        };
    },
    methods: {
		wxConfig(){
			let _this = this
			getAction('/wechat/sign',{
				url: window.location.href
			}).then(res => {
				wx.config({
					debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
					appId: this.appId, // 必填，公众号的唯一标识
					timestamp: res.timestamp, // 必填，生成签名的时间戳
					nonceStr: res.nonceStr, // 必填，生成签名的随机串
					signature: res.signature,// 必填，签名
					jsApiList: ['updateAppMessageShareData','updateTimelineShareData'] // 必填，需要使用的JS接口列表
				});
				wx.ready(function(){
					// 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
					wx.updateAppMessageShareData({ 
						title: window._CONFIG['title'], // 分享标题
						desc: '“十四五”期间，以习近平新时代中国特色社会主义思想为指导，全面贯彻党的十九大和十九届二中、三中、四中、五中全会精神，坚持新发展理念，适应新发展阶段，融入新发展格局，以深化供给侧结构性改革为主线，以发展实体经济，坚定不移走制造强市之路，坚持“改旧”和“育新”并重，保持制造业比重稳步提升，着力打造先进石化、装备制造、生物医药、绿色冶金四大千亿优势产业集群，培育壮大航空航天、新材料、新能源、核燃料、新型建材、节能环保、食品加工、烟草制品八个百亿支柱产业链条，构建起多元支撑、稳定可靠的“四梁八柱”工业产业体系，实现工业产业创新、绿色、生态、集群化发展。', // 分享描述
						link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
						imgUrl: 'http://lzgxj.lxito.com/image/icon.png', // 分享图标
						success: function () {
							console.log('分享给朋友成功')
						}
					})
					// 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
					wx.updateTimelineShareData({ 
						title: window._CONFIG['title'], // 分享标题
						link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
						imgUrl: 'http://lzgxj.lxito.com/image/icon.png', // 分享图标
						success: function () {
							console.log('分享到朋友圈成功')
						}
					})
				})
				wx.error(function(res){

				});
			})
		},
    },
};
</script>

<style lang="scss">
.body-bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -10;
}
.bg-box {
    width: 100%;
    .bg {
        width: 100%;
        position: fixed;
        top: 0;
    }
    .line {
        .ie {
            width: 100%;
            position: fixed;
            top: 0;
        }
    }
}
.dhuang {
    img {
        width: 20%;
        position: fixed;
        top: 5%;
        right: 0;
        -webkit-animation: slide-in-blurred-right 0.6s
            cubic-bezier(0.23, 1, 0.32, 1) both;
        animation: slide-in-blurred-right 0.6s cubic-bezier(0.23, 1, 0.32, 1)
            both;
    }
}
</style>

